import { Component, OnInit } from '@angular/core';
import { BlogService } from '../../services/blog.service';
import { Blog } from '../../classes/blogs.interface';


@Component({
  selector: 'app-breedmain',
  templateUrl: './breedmain.component.html',
  styleUrls: ['./breedmain.component.css']
})
export class BreedmainComponent implements OnInit {
breedinfo: any;
public loading = false;


  constructor(private blogService: BlogService) {

   }

  ngOnInit() {
    this.loading = true;
    this.getBreedreedinfo();

  }
  getBreedreedinfo() {
    this.blogService.getBreedsInfo()
    .subscribe(
      (x) => {
        this.loading = false;
        this.breedinfo = x;
      }
    );
  }
}
